export class EntLogisticsCenterFilter {
  page: number;
  size: number;
  deleted: boolean;
  centerName?: string;
  regionId?: number;
  areaId?: number;
  territorialUnitId?: number;

  constructor(init?: Partial<EntLogisticsCenterFilter>) {
	this.page = 1;
	this.size = 1000;
	this.deleted = false;
	if (init) {
	  Object.assign(this, init)
	}
  }
}
